// extracted by mini-css-extract-plugin
module.exports = {"container":"container__styles__container--2Zg0fsZw"};